import { cn } from '@/lib/utils'
import type { AmountCalloutLargest } from './types'

export interface AmountCalloutProps {
  totalAmountEur: number
  largest?: AmountCalloutLargest
  deltaEur?: number
  locale?: string
  className?: string
}

function formatEur(value: number, locale: string) {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: 'EUR',
    maximumFractionDigits: 0,
  }).format(value)
}

export function AmountCallout({
  totalAmountEur,
  largest,
  deltaEur,
  locale = 'en-GB',
  className,
}: AmountCalloutProps) {
  const hasDelta = typeof deltaEur === 'number' && Number.isFinite(deltaEur)
  const deltaPrefix = hasDelta && deltaEur > 0 ? '+' : ''

  return (
    <div className={cn('space-y-3 rounded-xl border border-border p-3', className)}>
      <div>
        <p className="text-xs font-medium uppercase tracking-wide text-muted-foreground">
          Total new fines
        </p>
        <p className="text-3xl font-semibold text-foreground">
          {formatEur(totalAmountEur, locale)}
        </p>
      </div>
      {largest ? (
        <p className="text-sm text-muted-foreground">
          Largest: <span className="font-medium text-foreground">{largest.organisation}</span>{' '}
          at {formatEur(largest.amountEur, locale)}.
        </p>
      ) : null}
      {hasDelta ? (
        <p className="text-sm text-muted-foreground">
          Delta: {deltaPrefix}
          {formatEur(deltaEur, locale)}.
        </p>
      ) : null}
    </div>
  )
}
